<template>
    <ui-crud title="Materials" subtitle="Manage the central materials list." :fetch="fetch" :group-by="groupByLetters">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search" @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, selectItem, active, setLoadingDetails }">
            <ui-crud-card
                :title="item.name"
                :active="active"
                @click="fetchMaterial(item, selectItem, setLoadingDetails)"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <assets-materials-form :add-item="addItem" :categories="categories"></assets-materials-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <assets-materials-form :item="selectedItem" :edit="setEditMode" :categories="categories"></assets-materials-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <assets-materials-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></assets-materials-show>
        </template>
    </ui-crud>
</template>

<script>
import { sortBy } from 'lodash'
import { Material, MaterialCategory } from '@models'

export default {
    data () {
        return {
            search: '',
            categories: [],
        }
    },
    methods: {
        async fetch () {
            const materials = await Material.search(this.search, true)
            return sortBy(materials, material => material.name.trim())
        },
        async fetchMaterial (item, selectItem, setLoadingDetails) {
            try {
                setLoadingDetails(true)
                const material = await Material.find(item.id)
                selectItem(material)
            } finally {
                setLoadingDetails(false)
            }
        },
        groupByLetters (material) {
            const name = material.name.trim()
            const letter = (name[0] || '0').toUpperCase()
            return isNaN(letter) ? letter : '#';
        },
    },
    async mounted () {
        this.categories = (await MaterialCategory.all()).map(x => x.toDropdown())
    }
}
</script>
